import {
  StructuredTableColumn,
  TagValueStructuredTableColumn,
} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';

/**
 * Determine if the column is fillable in the Data Entry Agent feature.
 *
 * This should match is_column_editable in benchling/notebook/structured_tables/logic/column_editability.py.
 */
export default function isStructuredTableColumnFillable(column: StructuredTableColumn): boolean {
  if (column.isReadOnly || column.isProtected) {
    return false;
  }
  if (column.columnType === TableColumnType.TAG_VALUE) {
    // Unsafe cast due to type complexity, but this ideally would narrow to TagValueStructuredTableColumn.
    const tagValueColumn = column as TagValueStructuredTableColumn;
    if (
      tagValueColumn.schemaFieldIsComputed ||
      tagValueColumn.schemaFieldIsSnapshot ||
      tagValueColumn.schemaFieldIsConvertedFromLink
    ) {
      return false;
    }
  }
  return true;
}
